import template from "./selectFieldSearchable.html";
import controller from "./selectFieldSearchable.controller";

let component = {
  restrict: "E",
  template,
  controller,
  controllerAs: "vm",
  bindings: {
    fieldResponse: "<",
    onUpdate: "&",
  },
};

export default component;
